import type { Monaco } from '@monaco-editor/react';

import type { EnvironmentVariable } from '../types';
import { getCustomFunctionJsonSchema } from './helpers/getCustomFunctionJsonSchema';

/**
 * Add CustomFunction input argument JSON schema to validate test payloads
 *
 * @param monaco - monaco editor instance
 * @param filename - the filename, like `input-parameters.json`
 * @param envVars - environment variables for the custom function
 */
function addCustomFunctionJsonSchema(
  monaco: Monaco,
  filename: string,
  envVars: EnvironmentVariable[],
): void {
  const schema = getCustomFunctionJsonSchema(envVars);

  monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
    validate: true,
    schemas: [
      {
        uri: `file:///${filename}`,
        fileMatch: ['*'],
        schema,
      },
    ],
  });
}

/**
 * Enable CustomFunction input argument JSON schema to validate test payloads
 *
 * @param monaco - monaco editor instance
 * @param filename - the filename, like `input-parameters.json`
 * @param envVars - environment variables for the custom function
 */
export function enableCustomFunctionJsonMode(
  monaco: Monaco,
  filename: string,
  envVars: EnvironmentVariable[],
): void {
  addCustomFunctionJsonSchema(monaco, filename, envVars);
}
